export const GET_TECHNICIANS = "GET_TECHNICIANS";
export const GET_TECHNICIANS_SUCCESS = "GET_TECHNICIANS_SUCCESS";
export const GET_TECHNICIANS_ERROR = "GET_TECHNICIANS_ERROR";
export const TOGGLE_TECHNICIAN_MODAL = "TOGGLE_TECHNICIAN_MODAL";

export const ADD_TECHNICIAN = "ADD_TECHNICIAN";
export const ADD_TECHNICIAN_SUCCESS = "ADD_TECHNICIAN_SUCCESS";
export const ADD_TECHNICIAN_ERROR = "ADD_TECHNICIAN_ERROR";

export const GET_TECHNICIAN = "GET_TECHNICIAN";
export const GET_TECHNICIAN_SUCCESS = "GET_TECHNICIAN_SUCCESS";
export const GET_TECHNICIAN_ERROR = "GET_TECHNICIAN_ERROR";

export const UPDATE_TECHNICIAN = "UPDATE_TECHNICIAN";
export const UPDATE_TECHNICIAN_SUCCESS = "UPDATE_TECHNICIAN_SUCCESS";
export const UPDATE_TECHNICIAN_ERROR = "UPDATE_TECHNICIAN_ERROR";

export const DELETE_TECHNICIAN = "DELETE_TECHNICIAN";
export const DELETE_TECHNICIAN_SUCCESS = "DELETE_TECHNICIAN_SUCCESS";
export const DELETE_TECHNICIAN_ERROR = "DELETE_TECHNICIAN_ERROR";

export const UPDATE_BLOCK_STATUS = "UPDATE_BLOCK_STATUS";
export const UPDATE_BLOCK_STATUS_SUCCESS = "UPDATE_BLOCK_STATUS_SUCCESS";
export const UPDATE_BLOCK_STATUS_ERROR = "UPDATE_BLOCK_STATUS_ERROR";

export const TOGGLE_TECHNICIAN_BLOCk_MODAL = "TOGGLE_TECHNICIAN_BLOCK_MODAL";

export const GET_TECHNICIAN_PURCHASES = "GET_TECHNICIAN_PURCHASES";
export const GET_TECHNICIAN_PURCHASES_SUCCESS =
  "GET_TECHNICIAN_PURCHASES_SUCCESS";
export const GET_TECHNICIAN_PURCHASES_ERROR = "GET_TECHNICIAN_PURCHASES_ERROR";

export const CHANGE_TECHNICIAN_REMAINING_CALLS =
  "CHANGE_TECHNICIAN_REMAINING_CALLS";
export const CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS =
  "CHANGE_TECHNICIAN_REMAINING_CALLS_SUCCESS";
export const CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR =
  "CHANGE_TECHNICIAN_REMAINING_CALLS_ERROR";
